module.exports = __webpack_public_path__ + "static/media/wavm8s-002-will-lux.3692033.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-002-will-lux.mp3
// module id = DPso
// module chunks = 0